@file:OptIn(InternalResourceApi::class)

package com.nonopn.skywatcher.common.app.res

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.nonopn.skywatcher.common.app.res/"

@delegate:ResourceContentHash(-9_937_212)
internal val Res.string.menu_admin_strikeradar_map: StringResource by lazy {
      StringResource("string:menu_admin_strikeradar_map", "menu_admin_strikeradar_map", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30658, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30846, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30318, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28638, 46),
      ))
    }

@delegate:ResourceContentHash(2_075_710_520)
internal val Res.string.menu_cert_nsg: StringResource by lazy {
      StringResource("string:menu_cert_nsg", "menu_cert_nsg", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30721, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30897, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30369, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28685, 41),
      ))
    }

@delegate:ResourceContentHash(1_111_052_896)
internal val Res.string.menu_keraunic_report: StringResource by lazy {
      StringResource("string:menu_keraunic_report", "menu_keraunic_report", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30763, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30939, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30411, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28727, 48),
      ))
    }

@delegate:ResourceContentHash(1_161_238_106)
internal val Res.string.menu_sr_account: StringResource by lazy {
      StringResource("string:menu_sr_account", "menu_sr_account", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30816, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30996, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30468, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28776, 39),
      ))
    }

@delegate:ResourceContentHash(314_088_360)
internal val Res.string.menu_sr_activity: StringResource by lazy {
      StringResource("string:menu_sr_activity", "menu_sr_activity", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30852, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31036, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30508, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28816, 40),
      ))
    }

@delegate:ResourceContentHash(-306_259_549)
internal val Res.string.menu_sr_cert_nsg: StringResource by lazy {
      StringResource("string:menu_sr_cert_nsg", "menu_sr_cert_nsg", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30897, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31085, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30553, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28857, 48),
      ))
    }

@delegate:ResourceContentHash(-3_149_112)
internal val Res.string.menu_sr_certificates: StringResource by lazy {
      StringResource("string:menu_sr_certificates", "menu_sr_certificates", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30946, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31130, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30602, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28906, 68),
      ))
    }

@delegate:ResourceContentHash(-1_938_971_205)
internal val Res.string.menu_sr_dashboard: StringResource by lazy {
      StringResource("string:menu_sr_dashboard", "menu_sr_dashboard", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31003, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31195, 45),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30683, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28975, 37),
      ))
    }

@delegate:ResourceContentHash(-1_029_143_422)
internal val Res.string.menu_sr_documents: StringResource by lazy {
      StringResource("string:menu_sr_documents", "menu_sr_documents", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31053, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31241, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30717, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29013, 57),
      ))
    }

@delegate:ResourceContentHash(1_768_260_966)
internal val Res.string.menu_sr_impacts: StringResource by lazy {
      StringResource("string:menu_sr_impacts", "menu_sr_impacts", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31111, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31299, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30779, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29071, 35),
      ))
    }

@delegate:ResourceContentHash(1_682_548_918)
internal val Res.string.menu_sr_keraunic: StringResource by lazy {
      StringResource("string:menu_sr_keraunic", "menu_sr_keraunic", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31147, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31335, 52),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30815, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29107, 48),
      ))
    }

@delegate:ResourceContentHash(956_509_435)
internal val Res.string.menu_sr_map: StringResource by lazy {
      StringResource("string:menu_sr_map", "menu_sr_map", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31200, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31388, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30872, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29156, 23),
      ))
    }

@delegate:ResourceContentHash(2_087_928_653)
internal val Res.string.menu_sr_probes: StringResource by lazy {
      StringResource("string:menu_sr_probes", "menu_sr_probes", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31228, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31416, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30900, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29180, 34),
      ))
    }

@delegate:ResourceContentHash(285_980_640)
internal val Res.string.menu_sr_projects: StringResource by lazy {
      StringResource("string:menu_sr_projects", "menu_sr_projects", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31263, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31451, 52),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30935, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29215, 52),
      ))
    }

@delegate:ResourceContentHash(-356_419_905)
internal val Res.string.menu_sr_settings: StringResource by lazy {
      StringResource("string:menu_sr_settings", "menu_sr_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31316, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31504, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30988, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29268, 36),
      ))
    }

@delegate:ResourceContentHash(1_223_911_894)
internal val Res.string.menu_sr_sponsorship: StringResource by lazy {
      StringResource("string:menu_sr_sponsorship", "menu_sr_sponsorship", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31353, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31545, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31033, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29305, 43),
      ))
    }

@delegate:ResourceContentHash(-1_015_121_091)
internal val Res.string.menu_sr_subscription: StringResource by lazy {
      StringResource("string:menu_sr_subscription", "menu_sr_subscription", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31397, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31589, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31077, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29349, 44),
      ))
    }

@delegate:ResourceContentHash(1_273_201_644)
internal val Res.string.menu_strikeradar_certificates: StringResource by lazy {
      StringResource("string:menu_strikeradar_certificates", "menu_strikeradar_certificates", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31442, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31634, 77),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31122, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29394, 77),
      ))
    }

@delegate:ResourceContentHash(-2_037_906_480)
internal val Res.string.menu_strikeradar_densities: StringResource by lazy {
      StringResource("string:menu_strikeradar_densities", "menu_strikeradar_densities", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31508, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31712, 70),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31212, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29472, 62),
      ))
    }

@delegate:ResourceContentHash(956_509_435)
internal val Res.string.menu_strikeradar_map: StringResource by lazy {
      StringResource("string:menu_strikeradar_map", "menu_strikeradar_map", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31571, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31783, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31279, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29535, 32),
      ))
    }

@delegate:ResourceContentHash(2_025_026_432)
internal val Res.string.menu_title_strikeradar: StringResource by lazy {
      StringResource("string:menu_title_strikeradar", "menu_title_strikeradar", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31665, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31877, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31373, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29625, 46),
      ))
    }

@delegate:ResourceContentHash(-190_489_131)
internal val Res.string.menu_title_strikeradar_admin: StringResource by lazy {
      StringResource("string:menu_title_strikeradar_admin", "menu_title_strikeradar_admin", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31608, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31820, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31316, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29568, 56),
      ))
    }

@delegate:ResourceContentHash(-1_337_292_866)
internal val Res.string.menu_user_estimate: StringResource by lazy {
      StringResource("string:menu_user_estimate", "menu_user_estimate", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31819, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32051, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31531, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29791, 54),
      ))
    }

@delegate:ResourceContentHash(-305_436_248)
internal val Res.string.menu_user_estimate_list: StringResource by lazy {
      StringResource("string:menu_user_estimate_list", "menu_user_estimate_list", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31712, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31924, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31420, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29672, 59),
      ))
    }

@delegate:ResourceContentHash(2_053_115_124)
internal val Res.string.menu_user_estimate_new: StringResource by lazy {
      StringResource("string:menu_user_estimate_new", "menu_user_estimate_new", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31768, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 31984, 66),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31476, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29732, 58),
      ))
    }

@delegate:ResourceContentHash(1_368_185_060)
internal val Res.string.new_scenario_option_draws: StringResource by lazy {
      StringResource("string:new_scenario_option_draws", "new_scenario_option_draws", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31866, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32106, 45),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31582, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29846, 45),
      ))
    }

@delegate:ResourceContentHash(-597_711_936)
internal val Res.string.new_scenario_option_mulligan: StringResource by lazy {
      StringResource("string:new_scenario_option_mulligan", "new_scenario_option_mulligan", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31912, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32152, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31628, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29892, 48),
      ))
    }

@delegate:ResourceContentHash(2_135_642_277)
internal val Res.string.new_scenario_text: StringResource by lazy {
      StringResource("string:new_scenario_text", "new_scenario_text", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 31961, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32201, 81),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31677, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29941, 97),
      ))
    }

@delegate:ResourceContentHash(601_481_371)
internal val Res.string.new_scenario_title: StringResource by lazy {
      StringResource("string:new_scenario_title", "new_scenario_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32047, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32283, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31791, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30039, 54),
      ))
    }

@delegate:ResourceContentHash(-209_997_448)
internal val Res.string.no_probe_coverage_add_probe: StringResource by lazy {
      StringResource("string:no_probe_coverage_add_probe", "no_probe_coverage_add_probe", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32106, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32334, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31850, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30094, 51),
      ))
    }

@delegate:ResourceContentHash(-1_603_301_277)
internal val Res.string.no_probe_coverage_message: StringResource by lazy {
      StringResource("string:no_probe_coverage_message", "no_probe_coverage_message", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32166, 229),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32394, 229),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 31914, 229),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30146, 189),
      ))
    }

@delegate:ResourceContentHash(747_774_349)
internal val Res.string.now: StringResource by lazy {
      StringResource("string:now", "now", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32418, 19),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32646, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32166, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30358, 15),
      ))
    }

@delegate:ResourceContentHash(-549_769_984)
internal val Res.string.now_after: StringResource by lazy {
      StringResource("string:now_after", "now_after", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32396, 21),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32624, 21),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32144, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30336, 21),
      ))
    }

@delegate:ResourceContentHash(-1_861_149_208)
internal val Res.string.number_sensors: StringResource by lazy {
      StringResource("string:number_sensors", "number_sensors", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32438, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32674, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32186, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30374, 42),
      ))
    }

@delegate:ResourceContentHash(1_316_618_752)
internal val Res.string.ok: StringResource by lazy {
      StringResource("string:ok", "ok", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32481, 14),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32717, 14),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32229, 14),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30417, 14),
      ))
    }

@delegate:ResourceContentHash(1_255_789_568)
internal val Res.string.otd: StringResource by lazy {
      StringResource("string:otd", "otd", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32496, 15),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32732, 15),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32244, 15),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30432, 15),
      ))
    }

@delegate:ResourceContentHash(1_256_158_976)
internal val Res.string.otp: StringResource by lazy {
      StringResource("string:otp", "otp", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32512, 15),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32748, 15),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32260, 15),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30448, 15),
      ))
    }

@delegate:ResourceContentHash(501_212_548)
internal val Res.string.pdf_lang_picker_subtitle: StringResource by lazy {
      StringResource("string:pdf_lang_picker_subtitle", "pdf_lang_picker_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32528, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32764, 84),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32276, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30464, 88),
      ))
    }

@delegate:ResourceContentHash(247_705_305)
internal val Res.string.pdf_lang_picker_title: StringResource by lazy {
      StringResource("string:pdf_lang_picker_title", "pdf_lang_picker_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32605, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32849, 61),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32349, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30553, 61),
      ))
    }

@delegate:ResourceContentHash(1_632_878_016)
internal val Res.string.polarity_cg_negative: StringResource by lazy {
      StringResource("string:polarity_cg_negative", "polarity_cg_negative", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32671, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32911, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32411, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30615, 36),
      ))
    }

@delegate:ResourceContentHash(-1_507_443_840)
internal val Res.string.polarity_cg_positive: StringResource by lazy {
      StringResource("string:polarity_cg_positive", "polarity_cg_positive", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32708, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32948, 32),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32448, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30652, 32),
      ))
    }

@delegate:ResourceContentHash(-1_823_009_685)
internal val Res.string.polarity_cg_title: StringResource by lazy {
      StringResource("string:polarity_cg_title", "polarity_cg_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32741, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 32981, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32481, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30685, 41),
      ))
    }

@delegate:ResourceContentHash(668_579_644)
internal val Res.string.probability_incidence: StringResource by lazy {
      StringResource("string:probability_incidence", "probability_incidence", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32783, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33023, 61),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32527, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30727, 61),
      ))
    }

@delegate:ResourceContentHash(19_769_692)
internal val Res.string.probe_action_finalize: StringResource by lazy {
      StringResource("string:probe_action_finalize", "probe_action_finalize", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32849, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33085, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32597, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30789, 53),
      ))
    }

@delegate:ResourceContentHash(-2_017_490_257)
internal val Res.string.probe_action_upgrade: StringResource by lazy {
      StringResource("string:probe_action_upgrade", "probe_action_upgrade", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32903, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33143, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32655, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30843, 60),
      ))
    }

@delegate:ResourceContentHash(-1_935_500_051)
internal val Res.string.probe_add_card: StringResource by lazy {
      StringResource("string:probe_add_card", "probe_add_card", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 32960, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33204, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32712, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30904, 38),
      ))
    }

@delegate:ResourceContentHash(-831_455_646)
internal val Res.string.probe_badge_expired: StringResource by lazy {
      StringResource("string:probe_badge_expired", "probe_badge_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33003, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33251, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32759, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30943, 59),
      ))
    }

@delegate:ResourceContentHash(-985_287_688)
internal val Res.string.probe_badge_trial: StringResource by lazy {
      StringResource("string:probe_badge_trial", "probe_badge_trial", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33071, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33315, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32823, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31003, 53),
      ))
    }

@delegate:ResourceContentHash(2_027_406_888)
internal val Res.string.probe_badge_unpaid: StringResource by lazy {
      StringResource("string:probe_badge_unpaid", "probe_badge_unpaid", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33133, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33373, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32885, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31057, 50),
      ))
    }

@delegate:ResourceContentHash(1_542_330_764)
internal val Res.string.probe_create_count: StringResource by lazy {
      StringResource("string:probe_create_count", "probe_create_count", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33188, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33432, 62),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32940, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31108, 50),
      ))
    }

@delegate:ResourceContentHash(-1_418_722_807)
internal val Res.string.probe_create_empty: StringResource by lazy {
      StringResource("string:probe_create_empty", "probe_create_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33247, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33495, 78),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 32995, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31159, 74),
      ))
    }

@delegate:ResourceContentHash(486_696_884)
internal val Res.string.probe_create_hint: StringResource by lazy {
      StringResource("string:probe_create_hint", "probe_create_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33470, 161),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33738, 185),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 33222, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31358, 133),
      ))
    }

@delegate:ResourceContentHash(-1_211_043_567)
internal val Res.string.probe_create_hint_trial: StringResource by lazy {
      StringResource("string:probe_create_hint_trial", "probe_create_hint_trial", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33326, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33574, 163),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 33074, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31234, 123),
      ))
    }

@delegate:ResourceContentHash(-1_258_637_619)
internal val Res.string.probe_create_item: StringResource by lazy {
      StringResource("string:probe_create_item", "probe_create_item", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33632, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33924, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 33380, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31492, 49),
      ))
    }

@delegate:ResourceContentHash(1_174_351_056)
internal val Res.string.probe_create_legend_existing: StringResource by lazy {
      StringResource("string:probe_create_legend_existing", "probe_create_legend_existing", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33682, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 33974, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 33430, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31542, 64),
      ))
    }

@delegate:ResourceContentHash(1_535_696_680)
internal val Res.string.probe_create_legend_new: StringResource by lazy {
      StringResource("string:probe_create_legend_new", "probe_create_legend_new", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33747, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34039, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 33503, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31607, 47),
      ))
    }

@delegate:ResourceContentHash(-832_276_422)
internal val Res.string.probe_create_pay: StringResource by lazy {
      StringResource("string:probe_create_pay", "probe_create_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33799, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34095, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 33551, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31655, 44),
      ))
    }

@delegate:ResourceContentHash(57_127_224)
internal val Res.string.probe_create_remove: StringResource by lazy {
      StringResource("string:probe_create_remove", "probe_create_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33844, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34144, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 33596, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31700, 35),
      ))
    }

@delegate:ResourceContentHash(681_163_597)
internal val Res.string.probe_create_start_trial: StringResource by lazy {
      StringResource("string:probe_create_start_trial", "probe_create_start_trial", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33880, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34184, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 33636, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31736, 52),
      ))
    }

@delegate:ResourceContentHash(-1_112_805_641)
internal val Res.string.probe_create_submitting: StringResource by lazy {
      StringResource("string:probe_create_submitting", "probe_create_submitting", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33937, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34241, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 33689, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31789, 51),
      ))
    }

@delegate:ResourceContentHash(-142_014_745)
internal val Res.string.probe_create_title: StringResource by lazy {
      StringResource("string:probe_create_title", "probe_create_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34066, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34370, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 33806, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31898, 50),
      ))
    }

@delegate:ResourceContentHash(240_253_978)
internal val Res.string.probe_create_title_trial: StringResource by lazy {
      StringResource("string:probe_create_title_trial", "probe_create_title_trial", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 33997, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34301, 68),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 33737, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31841, 56),
      ))
    }

@delegate:ResourceContentHash(-842_385_779)
internal val Res.string.probe_default_name: StringResource by lazy {
      StringResource("string:probe_default_name", "probe_default_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34117, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34421, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 33865, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31949, 42),
      ))
    }

@delegate:ResourceContentHash(-174_618_103)
internal val Res.string.probe_demo_exists_body: StringResource by lazy {
      StringResource("string:probe_demo_exists_body", "probe_demo_exists_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34160, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34464, 150),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 33908, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31992, 146),
      ))
    }

@delegate:ResourceContentHash(-1_529_395_072)
internal val Res.string.probe_demo_exists_pay: StringResource by lazy {
      StringResource("string:probe_demo_exists_pay", "probe_demo_exists_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34303, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34615, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 34047, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32139, 53),
      ))
    }

@delegate:ResourceContentHash(1_847_512_245)
internal val Res.string.probe_demo_exists_title: StringResource by lazy {
      StringResource("string:probe_demo_exists_title", "probe_demo_exists_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34353, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34665, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 34105, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32193, 55),
      ))
    }

@delegate:ResourceContentHash(-1_349_805_173)
internal val Res.string.probe_err_account_has_probes_body: StringResource by lazy {
      StringResource("string:probe_err_account_has_probes_body", "probe_err_account_has_probes_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34413, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34725, 145),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 34165, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32249, 149),
      ))
    }

@delegate:ResourceContentHash(-526_789_874)
internal val Res.string.probe_err_account_has_probes_title: StringResource by lazy {
      StringResource("string:probe_err_account_has_probes_title", "probe_err_account_has_probes_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34551, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34871, 66),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 34299, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32399, 66),
      ))
    }

@delegate:ResourceContentHash(-404_239_146)
internal val Res.string.probe_err_invalid_name_body: StringResource by lazy {
      StringResource("string:probe_err_invalid_name_body", "probe_err_invalid_name_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34618, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 34938, 123),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 34370, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32466, 123),
      ))
    }

@delegate:ResourceContentHash(1_685_066_357)
internal val Res.string.probe_err_invalid_name_title: StringResource by lazy {
      StringResource("string:probe_err_invalid_name_title", "probe_err_invalid_name_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34754, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35062, 52),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 34498, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32590, 52),
      ))
    }

@delegate:ResourceContentHash(299_590_682)
internal val Res.string.probe_err_invalid_position_body: StringResource by lazy {
      StringResource("string:probe_err_invalid_position_body", "probe_err_invalid_position_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34815, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35115, 135),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 34555, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32643, 119),
      ))
    }

@delegate:ResourceContentHash(-1_304_455_002)
internal val Res.string.probe_err_invalid_position_title: StringResource by lazy {
      StringResource("string:probe_err_invalid_position_title", "probe_err_invalid_position_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 34951, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35251, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 34687, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32763, 64),
      ))
    }

@delegate:ResourceContentHash(528_335_554)
internal val Res.string.probe_err_no_demo_body: StringResource by lazy {
      StringResource("string:probe_err_no_demo_body", "probe_err_no_demo_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35020, 154),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35316, 142),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 34756, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32828, 130),
      ))
    }

@delegate:ResourceContentHash(-1_655_823_475)
internal val Res.string.probe_err_no_demo_title: StringResource by lazy {
      StringResource("string:probe_err_no_demo_title", "probe_err_no_demo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35175, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35459, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 34915, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32959, 59),
      ))
    }

@delegate:ResourceContentHash(358_695_070)
internal val Res.string.probe_err_pending_payment_body: StringResource by lazy {
      StringResource("string:probe_err_pending_payment_body", "probe_err_pending_payment_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35239, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35523, 142),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 34979, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33019, 142),
      ))
    }

@delegate:ResourceContentHash(1_672_821_851)
internal val Res.string.probe_err_pending_payment_title: StringResource by lazy {
      StringResource("string:probe_err_pending_payment_title", "probe_err_pending_payment_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35362, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35666, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 35110, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33162, 67),
      ))
    }

@delegate:ResourceContentHash(-1_147_548_755)
internal val Res.string.probe_err_too_many_requests_body: StringResource by lazy {
      StringResource("string:probe_err_too_many_requests_body", "probe_err_too_many_requests_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35422, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35730, 104),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 35174, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33230, 104),
      ))
    }

@delegate:ResourceContentHash(361_240_201)
internal val Res.string.probe_err_too_many_requests_title: StringResource by lazy {
      StringResource("string:probe_err_too_many_requests_title", "probe_err_too_many_requests_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35543, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35835, 65),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 35291, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33335, 65),
      ))
    }

@delegate:ResourceContentHash(-311_885_090)
internal val Res.string.probe_error_body: StringResource by lazy {
      StringResource("string:probe_error_body", "probe_error_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35617, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35901, 96),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 35357, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33401, 100),
      ))
    }

@delegate:ResourceContentHash(-2_002_989_627)
internal val Res.string.probe_error_title: StringResource by lazy {
      StringResource("string:probe_error_title", "probe_error_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35718, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 35998, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 35462, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33502, 53),
      ))
    }

@delegate:ResourceContentHash(369_609_729)
internal val Res.string.probe_nothing_to_pay_body: StringResource by lazy {
      StringResource("string:probe_nothing_to_pay_body", "probe_nothing_to_pay_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35776, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36056, 137),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 35508, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33556, 125),
      ))
    }

@delegate:ResourceContentHash(-751_928_940)
internal val Res.string.probe_nothing_to_pay_title: StringResource by lazy {
      StringResource("string:probe_nothing_to_pay_title", "probe_nothing_to_pay_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35898, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36194, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 35654, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33682, 54),
      ))
    }

@delegate:ResourceContentHash(907_792_562)
internal val Res.string.probe_nsg_promo_body: StringResource by lazy {
      StringResource("string:probe_nsg_promo_body", "probe_nsg_promo_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 35953, 236),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36249, 248),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 35705, 228),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33737, 216),
      ))
    }

@delegate:ResourceContentHash(-1_555_824_840)
internal val Res.string.probe_nsg_promo_cta: StringResource by lazy {
      StringResource("string:probe_nsg_promo_cta", "probe_nsg_promo_cta", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36190, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36498, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 35934, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33954, 47),
      ))
    }

@delegate:ResourceContentHash(1_255_154_781)
internal val Res.string.probe_nsg_promo_title: StringResource by lazy {
      StringResource("string:probe_nsg_promo_title", "probe_nsg_promo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36238, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36546, 65),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 35990, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34002, 65),
      ))
    }

@delegate:ResourceContentHash(1_554_666_020)
internal val Res.string.probe_paid_subscription_body: StringResource by lazy {
      StringResource("string:probe_paid_subscription_body", "probe_paid_subscription_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36304, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36612, 136),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 36056, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34068, 148),
      ))
    }

@delegate:ResourceContentHash(443_902_901)
internal val Res.string.probe_paid_subscription_title: StringResource by lazy {
      StringResource("string:probe_paid_subscription_title", "probe_paid_subscription_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36437, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36749, 61),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 36205, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34217, 61),
      ))
    }

@delegate:ResourceContentHash(1_681_653_026)
internal val Res.string.probe_pdf_blocked: StringResource by lazy {
      StringResource("string:probe_pdf_blocked", "probe_pdf_blocked", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36495, 169),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36811, 173),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 36267, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34279, 137),
      ))
    }

@delegate:ResourceContentHash(1_919_789_943)
internal val Res.string.probe_promo_b1: StringResource by lazy {
      StringResource("string:probe_promo_b1", "probe_promo_b1", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36665, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 36985, 86),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 36429, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34417, 74),
      ))
    }

@delegate:ResourceContentHash(571_626_196)
internal val Res.string.probe_promo_b2: StringResource by lazy {
      StringResource("string:probe_promo_b2", "probe_promo_b2", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36748, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37072, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 36508, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34492, 58),
      ))
    }

@delegate:ResourceContentHash(-1_115_627_774)
internal val Res.string.probe_promo_b3: StringResource by lazy {
      StringResource("string:probe_promo_b3", "probe_promo_b3", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36827, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37131, 94),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 36567, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34551, 90),
      ))
    }

@delegate:ResourceContentHash(1_255_154_781)
internal val Res.string.probe_promo_b4: StringResource by lazy {
      StringResource("string:probe_promo_b4", "probe_promo_b4", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36922, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37226, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 36666, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34642, 58),
      ))
    }

@delegate:ResourceContentHash(-142_014_745)
internal val Res.string.probe_promo_create: StringResource by lazy {
      StringResource("string:probe_promo_create", "probe_promo_create", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 36981, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37285, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 36725, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34701, 50),
      ))
    }

@delegate:ResourceContentHash(596_732_131)
internal val Res.string.probe_promo_title: StringResource by lazy {
      StringResource("string:probe_promo_title", "probe_promo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37032, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37336, 85),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 36784, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34752, 77),
      ))
    }

@delegate:ResourceContentHash(623_851_748)
internal val Res.string.probe_promo_trial: StringResource by lazy {
      StringResource("string:probe_promo_trial", "probe_promo_trial", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37209, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37513, 65),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 36969, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34917, 53),
      ))
    }

@delegate:ResourceContentHash(1_416_333_568)
internal val Res.string.probe_promo_trial_note: StringResource by lazy {
      StringResource("string:probe_promo_trial_note", "probe_promo_trial_note", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37110, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37422, 90),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 36874, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34830, 86),
      ))
    }

@delegate:ResourceContentHash(872_771_398)
internal val Res.string.probe_trial_banner_last_day: StringResource by lazy {
      StringResource("string:probe_trial_banner_last_day", "probe_trial_banner_last_day", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37267, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37579, 147),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 37035, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34971, 131),
      ))
    }

@delegate:ResourceContentHash(635_609_939)
internal val Res.string.probe_trial_banner_week: StringResource by lazy {
      StringResource("string:probe_trial_banner_week", "probe_trial_banner_week", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37411, 147),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37727, 159),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 37171, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35103, 135),
      ))
    }

@delegate:ResourceContentHash(43_686_196)
internal val Res.string.probe_trial_rights: StringResource by lazy {
      StringResource("string:probe_trial_rights", "probe_trial_rights", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37559, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37887, 66),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 37315, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35239, 58),
      ))
    }

@delegate:ResourceContentHash(-722_949_135)
internal val Res.string.probe_unavailable_body: StringResource by lazy {
      StringResource("string:probe_unavailable_body", "probe_unavailable_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 37630, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 37954, 130),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 37386, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35298, 110),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString4Resources(map: MutableMap<String, StringResource>) {
  map.put("menu_admin_strikeradar_map", Res.string.menu_admin_strikeradar_map)
  map.put("menu_cert_nsg", Res.string.menu_cert_nsg)
  map.put("menu_keraunic_report", Res.string.menu_keraunic_report)
  map.put("menu_sr_account", Res.string.menu_sr_account)
  map.put("menu_sr_activity", Res.string.menu_sr_activity)
  map.put("menu_sr_cert_nsg", Res.string.menu_sr_cert_nsg)
  map.put("menu_sr_certificates", Res.string.menu_sr_certificates)
  map.put("menu_sr_dashboard", Res.string.menu_sr_dashboard)
  map.put("menu_sr_documents", Res.string.menu_sr_documents)
  map.put("menu_sr_impacts", Res.string.menu_sr_impacts)
  map.put("menu_sr_keraunic", Res.string.menu_sr_keraunic)
  map.put("menu_sr_map", Res.string.menu_sr_map)
  map.put("menu_sr_probes", Res.string.menu_sr_probes)
  map.put("menu_sr_projects", Res.string.menu_sr_projects)
  map.put("menu_sr_settings", Res.string.menu_sr_settings)
  map.put("menu_sr_sponsorship", Res.string.menu_sr_sponsorship)
  map.put("menu_sr_subscription", Res.string.menu_sr_subscription)
  map.put("menu_strikeradar_certificates", Res.string.menu_strikeradar_certificates)
  map.put("menu_strikeradar_densities", Res.string.menu_strikeradar_densities)
  map.put("menu_strikeradar_map", Res.string.menu_strikeradar_map)
  map.put("menu_title_strikeradar", Res.string.menu_title_strikeradar)
  map.put("menu_title_strikeradar_admin", Res.string.menu_title_strikeradar_admin)
  map.put("menu_user_estimate", Res.string.menu_user_estimate)
  map.put("menu_user_estimate_list", Res.string.menu_user_estimate_list)
  map.put("menu_user_estimate_new", Res.string.menu_user_estimate_new)
  map.put("new_scenario_option_draws", Res.string.new_scenario_option_draws)
  map.put("new_scenario_option_mulligan", Res.string.new_scenario_option_mulligan)
  map.put("new_scenario_text", Res.string.new_scenario_text)
  map.put("new_scenario_title", Res.string.new_scenario_title)
  map.put("no_probe_coverage_add_probe", Res.string.no_probe_coverage_add_probe)
  map.put("no_probe_coverage_message", Res.string.no_probe_coverage_message)
  map.put("now", Res.string.now)
  map.put("now_after", Res.string.now_after)
  map.put("number_sensors", Res.string.number_sensors)
  map.put("ok", Res.string.ok)
  map.put("otd", Res.string.otd)
  map.put("otp", Res.string.otp)
  map.put("pdf_lang_picker_subtitle", Res.string.pdf_lang_picker_subtitle)
  map.put("pdf_lang_picker_title", Res.string.pdf_lang_picker_title)
  map.put("polarity_cg_negative", Res.string.polarity_cg_negative)
  map.put("polarity_cg_positive", Res.string.polarity_cg_positive)
  map.put("polarity_cg_title", Res.string.polarity_cg_title)
  map.put("probability_incidence", Res.string.probability_incidence)
  map.put("probe_action_finalize", Res.string.probe_action_finalize)
  map.put("probe_action_upgrade", Res.string.probe_action_upgrade)
  map.put("probe_add_card", Res.string.probe_add_card)
  map.put("probe_badge_expired", Res.string.probe_badge_expired)
  map.put("probe_badge_trial", Res.string.probe_badge_trial)
  map.put("probe_badge_unpaid", Res.string.probe_badge_unpaid)
  map.put("probe_create_count", Res.string.probe_create_count)
  map.put("probe_create_empty", Res.string.probe_create_empty)
  map.put("probe_create_hint", Res.string.probe_create_hint)
  map.put("probe_create_hint_trial", Res.string.probe_create_hint_trial)
  map.put("probe_create_item", Res.string.probe_create_item)
  map.put("probe_create_legend_existing", Res.string.probe_create_legend_existing)
  map.put("probe_create_legend_new", Res.string.probe_create_legend_new)
  map.put("probe_create_pay", Res.string.probe_create_pay)
  map.put("probe_create_remove", Res.string.probe_create_remove)
  map.put("probe_create_start_trial", Res.string.probe_create_start_trial)
  map.put("probe_create_submitting", Res.string.probe_create_submitting)
  map.put("probe_create_title", Res.string.probe_create_title)
  map.put("probe_create_title_trial", Res.string.probe_create_title_trial)
  map.put("probe_default_name", Res.string.probe_default_name)
  map.put("probe_demo_exists_body", Res.string.probe_demo_exists_body)
  map.put("probe_demo_exists_pay", Res.string.probe_demo_exists_pay)
  map.put("probe_demo_exists_title", Res.string.probe_demo_exists_title)
  map.put("probe_err_account_has_probes_body", Res.string.probe_err_account_has_probes_body)
  map.put("probe_err_account_has_probes_title", Res.string.probe_err_account_has_probes_title)
  map.put("probe_err_invalid_name_body", Res.string.probe_err_invalid_name_body)
  map.put("probe_err_invalid_name_title", Res.string.probe_err_invalid_name_title)
  map.put("probe_err_invalid_position_body", Res.string.probe_err_invalid_position_body)
  map.put("probe_err_invalid_position_title", Res.string.probe_err_invalid_position_title)
  map.put("probe_err_no_demo_body", Res.string.probe_err_no_demo_body)
  map.put("probe_err_no_demo_title", Res.string.probe_err_no_demo_title)
  map.put("probe_err_pending_payment_body", Res.string.probe_err_pending_payment_body)
  map.put("probe_err_pending_payment_title", Res.string.probe_err_pending_payment_title)
  map.put("probe_err_too_many_requests_body", Res.string.probe_err_too_many_requests_body)
  map.put("probe_err_too_many_requests_title", Res.string.probe_err_too_many_requests_title)
  map.put("probe_error_body", Res.string.probe_error_body)
  map.put("probe_error_title", Res.string.probe_error_title)
  map.put("probe_nothing_to_pay_body", Res.string.probe_nothing_to_pay_body)
  map.put("probe_nothing_to_pay_title", Res.string.probe_nothing_to_pay_title)
  map.put("probe_nsg_promo_body", Res.string.probe_nsg_promo_body)
  map.put("probe_nsg_promo_cta", Res.string.probe_nsg_promo_cta)
  map.put("probe_nsg_promo_title", Res.string.probe_nsg_promo_title)
  map.put("probe_paid_subscription_body", Res.string.probe_paid_subscription_body)
  map.put("probe_paid_subscription_title", Res.string.probe_paid_subscription_title)
  map.put("probe_pdf_blocked", Res.string.probe_pdf_blocked)
  map.put("probe_promo_b1", Res.string.probe_promo_b1)
  map.put("probe_promo_b2", Res.string.probe_promo_b2)
  map.put("probe_promo_b3", Res.string.probe_promo_b3)
  map.put("probe_promo_b4", Res.string.probe_promo_b4)
  map.put("probe_promo_create", Res.string.probe_promo_create)
  map.put("probe_promo_title", Res.string.probe_promo_title)
  map.put("probe_promo_trial", Res.string.probe_promo_trial)
  map.put("probe_promo_trial_note", Res.string.probe_promo_trial_note)
  map.put("probe_trial_banner_last_day", Res.string.probe_trial_banner_last_day)
  map.put("probe_trial_banner_week", Res.string.probe_trial_banner_week)
  map.put("probe_trial_rights", Res.string.probe_trial_rights)
  map.put("probe_unavailable_body", Res.string.probe_unavailable_body)
}
